import axiosInstance from './axiosInstance';

export const notificationsAPI = {
  getNotifications: async (params = {}) => {
    const query = new URLSearchParams(params).toString();
    const url = query ? `/notifications/?${query}` : '/notifications/';
    const response = await axiosInstance.get(url);
    return response.data;
  },

  markSeen: async (notificationId) => {
    const response = await axiosInstance.post(`/notifications/${notificationId}/mark_seen/`);
    return response.data;
  },

  clearAll: async () => {
    const response = await axiosInstance.post('/notifications/clear_all/');
    return response.data;
  },
};
